var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cey1fm4sha",
    width: "202.9%",
    height: "189.7%",
    x: "-51.5%",
    y: "-44.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#cey1fm4sha)",
    transform: "translate(-1101 -705) translate(965 710) translate(143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    fill: "#FFF",
    stroke: "#2D2D44",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 7,
    r: 6,
    fill: "#FFF",
    stroke: "#2D2D44",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#2D2D44",
    strokeWidth: 2,
    d: "M26.08 25.863l3.669 7.648c.205.43.24.904.126 1.337-.114.434-.377.829-.768 1.103-.339.237-.743.315-1.12.248-.379-.067-.731-.277-.969-.617l-4.875-6.963 3.937-2.756zM7.92 25.863L4.251 33.51c-.205.43-.24.904-.126 1.337.114.434.377.829.768 1.103.339.237.743.315 1.12.248.379-.067.731-.277.969-.617l4.875-6.963-3.937-2.756z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 15,
    fill: "#FFF",
    stroke: "#2D2D44",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 16,
    y: 5,
    fill: "#2D2D44",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 16,
    y: 28,
    fill: "#2D2D44",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 4.5,
    y: 16.5,
    fill: "#2D2D44",
    rx: 1,
    transform: "rotate(-90 5.5 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    x: 27.5,
    y: 16.5,
    fill: "#2D2D44",
    rx: 1,
    transform: "rotate(-90 28.5 18)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 2,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9,
    x: 16,
    y: 10,
    fill: "#E05C55",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 11,
    x: 19.182,
    y: 15.682,
    fill: "#E05C55",
    rx: 1,
    transform: "rotate(135 20.182 21.182)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4c8f64721d6cb07c13969fff1589ae16.svg";
export { ForwardRef as ReactComponent };